import { useTranslation } from "react-i18next";
import { SceneLayout } from "src/components/SceneLayout";
import { H2 } from "src/atoms/typography";
import FullScreen from "src/atoms/FullScreen";
import { Spinner } from "@chakra-ui/react";

function Disconnecting() {
  const { t } = useTranslation();
  return (
    <FullScreen position="fixed">
      <SceneLayout
        center={
          <>
            <H2
              color="highEmphasis"
              mb={["32px", "44px", "52px"]}
              fontSize={["2rem", "2.8rem", "3.2rem"]}
            >
              {t("disconnecting")}
            </H2>
            <Spinner
              width={["24px", "32px", "34px"]}
              height={["24px", "32px", "34px"]}
            />
          </>
        }
      />
    </FullScreen>
  );
}

export default Disconnecting;
